import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Mapa } from '@vr/mapa';
import { useSelector } from 'react-redux';
import { Modal } from '../components';
import { ec } from '../helpers/api';
import { JVCEF } from '~/config/constants';
import getCompanyFirstNameByIssuer from '../helpers/getCompanyFirstNameByIssuer';

const MapsModal = styled(Modal)`
  #mapa-main-container {
    background: transparent;
    border-radius: 10px;

    #vr-mapa {
      border-radius: 10px;
      overflow: hidden;

      // Botão fechar popup
      .gm-style .gm-style-iw.gm-style-iw-c {
        overflow: inherit;
      }
    }

    // Caixa de resultados
    #box-container {
      @media (max-width: ${({ theme }) => theme.devices.mobile}) {
        bottom: 40px;
      }

      &.btn-box-closed {
        left: -20px;
      }

      label {
        margin-bottom: 0;
      }
    }

    // Cards da listagem dos resultados
    #lista-resultados {
      @media (max-width: ${({ theme }) => theme.devices.mobile}) {
        max-height: 187px;
      }
    }
  }

  .MuiDialogContent-root {
    overflow-y: inherit;
  }

  .MuiButtonBase-root {
    z-index: 10;
  }
`;

const debounce = (() => {
  let time;
  return func => {
    clearTimeout(time);
    time = setTimeout(func);
  };
})();

function Maps({ show, handleClose }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [heightMap, setHeightMap] = useState('80vh');
  const issuerName = useSelector(state => state?.issuer?.name);

  useEffect(() => {
    const onResize = () => {
      debounce(() => setScreenWidth(window.innerWidth));
    };

    window.addEventListener('resize', onResize, false);
    return () => {
      window.removeEventListener('resize', onResize, false);
    };
  }, []);

  useEffect(() => {
    setHeightMap(screenWidth > 560 ? '80vh' : '97vh');
  }, [screenWidth]);

  function getProducts() {
    if (issuerName === JVCEF) {
      return [
        '00270', // Caixa Refeição
        '00290', // Caixa Alimentação
      ];
    }

    return [
      '00027', // VR Alimentação
      '00031', // VR Refeição
      '00028', // VR Auto
      '00030', // VR Cultura
      '00203', // VR Compras
      '00201', // VR Alimentação Cesta
      '00202', // VR Alimentação Natal
    ];
  }

  async function findLocations(filter) {
    setIsLoading(true);
    try {
      const params = {
        distance: filter.raio,
        lat: filter.lat,
        lon: filter.lon,
        radius: filter.raio,
        product: filter.produto,
        term: filter.estabelechiment,
        delivery: filter.delivery,
      };

      const data = await ec.searchEcs(params);

      const estabelecimentos = data.map(item => {
        const [latitude, longitude] = item.localizacao.split(',');
        return {
          ...item,
          latitude,
          longitude,
        };
      });

      setLocations(estabelecimentos);
    } catch (e) {
      setLocations([]);
    }
    setIsLoading(false);
  }

  return (
    <MapsModal open={show} handleClose={handleClose} maxWidth="lg" fullWidth>
      <>
        {show && (
          <Mapa
            issuer={issuerName}
            loadGooogleMapsScript={false}
            findEstablishment={findLocations}
            locations={locations}
            products={getProducts()}
            isLoading={isLoading}
            showResumoResultados
            enableUserLocation
            height={heightMap}
            companyName={getCompanyFirstNameByIssuer(issuerName)}
            open
          />
        )}
      </>
    </MapsModal>
  );
}

Maps.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default Maps;
